<app-gradient-bg class="fade-in"></app-gradient-bg>

<div>
	@if (loading) {
		<nz-spin nzSimple nzSize="large"></nz-spin>
	}

	<br />

	<h1 class="fade-in-with-delay-10000">Something went wrong - please try again later.</h1>
</div>
